import React from "react";

function Card({ title, image, className = "" }) {
  return (
    <div className={`group relative overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-105 border border-gray-300 hover:border-gray-400 flex flex-col h-full ${className}`}>
      {/* Image Container */}
      <div className="relative h-64 overflow-hidden rounded-t-3xl flex-shrink-0">
        <img 
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 via-gray-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        
        {/* Floating Action Button */}
        <div className="absolute top-4 right-4 w-14 h-14 bg-gradient-to-r from-gray-100 to-white backdrop-blur-sm rounded-full flex items-center justify-center shadow-xl opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-500 border border-gray-300">
          <svg className="w-7 h-7 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-10 bg-gradient-to-b from-gray-50 to-gray-100 flex-grow flex flex-col justify-between">
        {/* Title */}
        <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-6 text-center tracking-wide">
          {title}
        </h3>
        
        <div>
          {/* Features */}
          <div className="flex justify-center space-x-4 mb-6">
            <div className="flex items-center space-x-1 text-gray-600">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span className="text-sm font-medium">Garantía</span>
            </div>
            <div className="flex items-center space-x-1 text-gray-600">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
              </svg>
              <span className="text-sm font-medium">Financiación</span>
            </div>
          </div>
          
          {/* Button */}
          <button className="w-full py-4 px-6 bg-gradient-to-r from-gray-700 via-gray-800 to-gray-900 text-white font-bold rounded-2xl hover:from-gray-800 hover:via-gray-900 hover:to-gray-950 transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl border border-gray-600 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
            <span className="relative flex items-center justify-center space-x-2">
              <span>Ver Más</span>
              <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
          </button>
        </div>
      </div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-3 group-hover:opacity-8 transition-opacity duration-500 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%236b7280' fill-opacity='0.08'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      {/* Decorative Corner */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-gray-300/30 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>
  );
}

export default Card;